export default {
  BOOKING_REQUEST:  "mmb/BOOKING_REQUEST",
  BOOKING_RESPONSE: "mmb/BOOKING_RESPONSE",
}